var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.04999V5.07999C16.89 5.56999 19.5 8.46999 19.5 12C19.5 12.9 19.32 13.75 19.02 14.54L21.62 16.07C22.18 14.83 22.5 13.45 22.5 12C22.5 6.81999 18.55 2.54999 13.5 2.04999ZM12.5 19C8.63 19 5.5 15.87 5.5 12C5.5 8.46999 8.11 5.56999 11.5 5.07999V2.04999C6.44 2.54999 2.5 6.80999 2.5 12C2.5 17.52 6.97 22 12.49 22C15.8 22 18.73 20.39 20.55 17.91L17.95 16.38C16.67 17.98 14.71 19 12.5 19Z",
    fill: "#DB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedIcon);
export default __webpack_public_path__ + "static/media/redIcon.be725cd0ecf76ced98321d7f5c17135f.svg";
export { ForwardRef as ReactComponent };